import React from 'react';
import Typography from 'src/components/typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';
import Anchor from 'src/components/atomic/atoms/anchor/Anchor';
import { IconWarning } from '@americanexpress/dls-icons';
import { DLSSize } from 'src/types/dls-size.enum';
import styles from './ErrorBlock.module.scss';
import Selectors from 'src/utils/selectors';

export interface ErrorBlockProps {
    text: string;
    anchorText?: string;
    className?: string;
    onClick?: (e?: any) => void;
    href?: string;
}

export default function ErrorBlock({ text, anchorText, className, onClick, href }: ErrorBlockProps): JSX.Element {
    const action: JSX.Element = onClick && anchorText && (
        <Anchor
            typographyProps={{
                variant: TypographyVariants.LINK
            }}
            onClick={onClick}
            data-cy={Selectors.General.INLINE_ERROR_RETRY}
            href={href}
        >
            {anchorText}
        </Anchor>
    );

    return (
        <div className={`${styles.errorBlockContainer} ${className ?? ''}`} data-cy={Selectors.General.ERROR_BLOCK}>
            <IconWarning size={DLSSize.LARGE} className={styles.warningIcon} />
            <Typography variant={TypographyVariants.BODY} className={styles.errorText}>
                {text}
            </Typography>
            {action}
        </div>
    );
}
